'use strict';

// // infact = inferno + react

exports.React = require('react');
exports.ReactDOM = require('react-dom');
exports.Component = exports.React.Component;
exports.PropTypes = exports.React.PropTypes;